/* eslint-disable no-use-before-define */
/* eslint-disable no-mixed-operators */
/* eslint-disable eqeqeq */
import moment from 'moment';
import { formatPrice } from '../CommonUtils';

export function getPrice(
  tourAct,
  selectedFlight,
  tourInfo,
  insuranceChecked,
  promoCode,
) {
  let price = {};

  if (tourAct.price && isFlightPriceValid(selectedFlight.price)) {
    const { regular } = tourAct;
    const isReqular = regular && regular == 1;
    // Tez Tour
    if (tourAct.operatorcode == 15 && !isReqular) {
      price = getTezTourPrice(
        tourAct,
        selectedFlight,
        tourInfo,
        insuranceChecked,
        promoCode,
      );
    } else {
      price = getCommonPrice(tourAct, selectedFlight, promoCode);
    }
  } else {
    price = getCommonPrice(tourAct, selectedFlight, promoCode);
  }

  return price;
}

function getCommonPrice(tourAct, selectedFlight, promoCode) {
  const price = {};
  let tourPrice = 0;
  let promoPrice = 0;
  let discount = 0;
  let currency;

  if (isFlightPriceValid(selectedFlight.price)) {
    currency = selectedFlight.price.currency;
    tourPrice = parseInt(selectedFlight.price.value, 10);
  } else if (tourAct.price) {
    currency = tourAct.currency;
    tourPrice = parseInt(tourAct.price, 10);
  }

  price.tourPrice = `${formatPrice(tourPrice)} ${currency}`;
  price.tourPriceValue = tourPrice;

  if (promoCode.value && promoCode.value > 0) {
    promoPrice = Math.ceil(
      tourPrice * ((100 - parseInt(promoCode.value, 10)) / 100),
    );

    discount = tourPrice - promoPrice;

    price.promoPrice = `${formatPrice(promoPrice)} ${currency}`;
    price.discount = `${formatPrice(discount)} ${currency}`;
  }

  if (promoPrice > 0) {
    price.totalPrice = `${formatPrice(promoPrice)} ${currency}`;
    price.totalValue = promoPrice;
  } else {
    price.totalPrice = `${formatPrice(tourPrice)} ${currency}`;
    price.totalValue = tourPrice;
  }

  return price;
}

function getTezTourPrice(
  tourAct,
  selectedFlight,
  tourInfo,
  insuranceChecked,
  promoCode,
) {
  let currency;
  if (tourAct.currency) {
    currency = tourAct.currency;
  } else if (selectedFlight.price.currency) {
    currency = selectedFlight.price.currency;
  }

  const price = {};

  const tourPrice = parseInt(tourAct.price, 10);
  price.tourPrice = `${formatPrice(tourPrice)} ${currency}`;
  price.tourPriceValue = tourPrice;

  const flightPrice = parseInt(selectedFlight.price.value, 10);

  let airPortCharge = 0;
  let insurancePrice = 0;

  let promoPrice = 0;
  let discount = 0;

  // insurance
  if (tourInfo && tourInfo.addpayments && tourInfo.addpayments.length === 1) {
    const airPortChargeArray = tourInfo.addpayments.filter(
      (e) => e.name === 'Аэропортовые сборы',
    );

    if (airPortChargeArray.length > 0) {
      if (airPortChargeArray[0].amount && airPortChargeArray[0].amount > 0) {
        airPortCharge = parseInt(airPortChargeArray[0].amount, 10);
        insurancePrice = Math.ceil(flightPrice - tourPrice - airPortCharge);

        price.insurancePrice = `${formatPrice(insurancePrice)} ${currency}`;
        price.insurancePriceValue = insurancePrice;
        price.insuranceName = 'Kupala 3000 (до 3000/чел)';
      }
    }
  }

  if (promoCode.value && promoCode.value > 0) {
    promoPrice = Math.ceil(
      tourPrice * ((100 - parseInt(promoCode.value, 10)) / 100),
    );

    discount = tourPrice - promoPrice;

    price.promoPrice = `${formatPrice(promoPrice)} ${currency}`;
    price.discount = `${formatPrice(discount)} ${currency}`;
  }

  let total = airPortCharge;

  if (promoPrice > 0) {
    total += promoPrice;
  } else {
    total += tourPrice;
  }

  if (insuranceChecked) {
    total += insurancePrice;
  }

  price.totalPrice = `${formatPrice(total)} ${currency}`;
  price.totalValue = total;

  return price;
}

export function getPriceSplit(acualizationData, operatorInfo) {
  let split = [100];

  if (acualizationData && operatorInfo && operatorInfo.splitEnabled) {
    const { departurecode, countrycode, flydate, regular } = acualizationData;
    const { departure, country } = getOperatorCountry(
      operatorInfo,
      departurecode,
      countrycode,
    );

    if (departure && departure.splitEnabled && country && country.split) {
      const splitItem =
        regular == 1 ? country.split.regularSplit : country.split.charterSplit;

      if (
        splitItem &&
        splitItem.splitEnabled &&
        flydate &&
        isDiffAccepted(flydate, splitItem.beforeDays)
      ) {
        split = (splitItem.split || []).filter((percent) => percent > 0);
      }
    }

    if (split.length === 0) {
      split.push(100);
    }
  }

  return split;
}

export function isFlightInsuranceAvailable(acualizationData, operatorInfo) {
  let resutl = true;
  // operatorInfo is empty until loaded
  if (acualizationData && operatorInfo && operatorInfo.departures) {
    const { departurecode, countrycode, flydate } = acualizationData;
    const { departure, country } = getOperatorCountry(
      operatorInfo,
      departurecode,
      countrycode,
    );

    if (!operatorInfo.insuranceEnabled) {
      resutl = false;
    } else if (departure && country) {
      const { insurance = {} } = country;

      if (!departure.insuranceEnabled || !insurance.insuranceEnabled) {
        resutl = false;
      } else if (flydate && insurance.beforeDays > 0) {
        resutl = isDiffAccepted(flydate, insurance.beforeDays);
      }
    }
  }

  return resutl;
}

// Days limit when insurance is hidden only because the flight is too close
export function getInsuranceBeforeDays(acualizationData, operatorInfo) {
  let result = 0;

  if (
    acualizationData &&
    acualizationData.flydate &&
    operatorInfo &&
    operatorInfo.departures &&
    operatorInfo.insuranceEnabled
  ) {
    const { departurecode, countrycode, flydate } = acualizationData;
    const { departure, country } = getOperatorCountry(
      operatorInfo,
      departurecode,
      countrycode,
    );

    if (departure && departure.insuranceEnabled && country) {
      const { insurance = {} } = country;

      if (
        insurance.insuranceEnabled &&
        insurance.beforeDays > 0 &&
        !isDiffAccepted(flydate, insurance.beforeDays)
      ) {
        result = insurance.beforeDays;
      }
    }
  }

  return result;
}

function getOperatorCountry(operatorInfo, departurecode, countrycode) {
  const departure =
    operatorInfo.departures && operatorInfo.departures[departurecode];
  const country =
    departure && departure.countries && departure.countries[countrycode];

  return { departure, country };
}

function isDiffAccepted(flydate, daysBefore) {
  const flight = moment(flydate, 'DD.MM.YYYY');
  const today = moment().startOf('day');

  return flight.diff(today, 'days') >= daysBefore;
}

function isFlightPriceValid(price) {
  return price && price.currency && price.value;
}
